import type { ScreenModule } from "../../../app/screen-module";
import { PlansPage } from "../pages";

export default {
	id: "system-admin.plans",
	path: "/system/plans",
	area: "system-admin",
	navGroup: "カタログ",
	label: "プラン / Entitlement",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PlansPage,
} satisfies ScreenModule;
